import { Box } from "@mantine/core";

interface SoundcloudEmbedProps {
  url?: string;
  title?: string;
}

export function SoundcloudEmbed({ url, title }: SoundcloudEmbedProps) {
  if (!url) return null;
  const src = `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23ff9800&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true`;

  return (
    <Box my="xl">
      <iframe
        src={src}
        title={title ?? "SoundCloud embed"}
        width="100%"
        height={300}
        style={{ border: "none", borderRadius: 12 }}
        allow="autoplay"
        scrolling="no"
        frameBorder="no"
      />
    </Box>
  );
}
